/**
 * Analytics - UI Events
 * 
 * @atomic - UI interaction tracking
 * @modular - Button, panel, tab tracking
 * 
 * Purpose: Track UI interactions and panel states
 * Exports: trackButtonClick, trackPanelStateChange, trackImmersiveTabClick
 */

import { trackEvent } from './core'

/**
 * Track button clicks
 */
export const trackButtonClick = (buttonAction, context, metadata = {}) => {
  trackEvent('Button', 'click', buttonAction, null, {
    context: context,
    ...metadata
  })
}

/**
 * Track immersive tab clicks
 */
export const trackImmersiveTabClick = (tabId, page, panelState) => {
  trackEvent('Immersive', 'tab_click', tabId, null, {
    page: page,
    panel_state: panelState
  })
}

/**
 * Track panel state changes
 */
export const trackPanelStateChange = (fromState, toState, activeTab, trigger, page) => {
  trackEvent('Immersive', 'panel_state_change', null, null, {
    from_state: fromState,
    to_state: toState,
    active_tab: activeTab,
    trigger: trigger,
    page: page
  })
}

/**
 * Track language change
 */
export const trackLanguageChange = (fromLanguage, toLanguage, source = 'language_tab', isAuthenticated = false) => {
  trackEvent('Settings', 'language_change', null, null, {
    from_language: fromLanguage,
    to_language: toLanguage,
    source: source,
    is_authenticated: isAuthenticated
  })
}

/**
 * Track announcement interactions
 */
export const trackAnnouncementInteraction = (announcementId, action, announcementTitle = null) => {
  trackEvent('Announcement', action, announcementTitle, null, {
    announcement_id: announcementId
  })
}
